interface Props {
  className?: string;
  rows?: number;
}

export function LoadingSkeleton({ className = '', rows = 3 }: Props) {
  return (
    <div
      className={`animate-pulse space-y-3 ${className}`}
      role="status"
      aria-label="Carregando..."
    >
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-4 w-full rounded bg-slate-700/40" />
      ))}
    </div>
  );
}
